import { FunctionComponent } from "react";

import dynamic from "next/dynamic";

import { ShareThisProps } from "./types";

// Disabled SSR to avoid memory leak caused by styled
export const ShareThis = dynamic(() => import("./ShareThisSsr").then((mod) => mod.ShareThisSsr), {
  ssr: false,
}) as FunctionComponent<ShareThisProps>;
